var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.d{fill:none;}.a,.b{stroke:#f90353;stroke-width:2px;}.b{fill:#fff;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195 -1465)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(200 1465)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 30,
    height: 30,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 1,
    y: 1,
    width: 28,
    height: 28,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(195 1484)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 8,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 8,
    cy: 8,
    r: 7
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8,
    transform: "translate(203 1488)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 8,
    transform: "translate(207 1492) rotate(90)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    transform: "translate(208 1473)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15,
    transform: "translate(208 1479)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10,
    transform: "translate(213 1485)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.a930160e1d3e09f83da92e089c4b656a.svg";
export { ForwardRef as ReactComponent };